// extracted by mini-css-extract-plugin
module.exports =  {"modal-content-slim-body":"_4mXzQ3H","modalContentSlimBody":"_4mXzQ3H"};